import React, { useState, useRef, useEffect } from 'react';
import './styles/EnvelopeCard.css';
import { sendOpenNotification } from '../utils/sendNotification';

const EnvelopeCard = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOpened, setIsOpened] = useState(false);
  const wrapperRef = useRef(null);
  const closeTimeoutRef = useRef(null);

  const handleClick = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }

    if (!isExpanded) {
      setIsExpanded(true);
    } else {
      setIsOpened(prev => !prev);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        if (closeTimeoutRef.current) {
          clearTimeout(closeTimeoutRef.current);
          closeTimeoutRef.current = null;
        }

        if (isOpened) {
          setIsOpened(false);
          closeTimeoutRef.current = setTimeout(() => {
            setIsExpanded(false);
          }, 850);
        } else if (isExpanded) {
          setIsExpanded(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isExpanded, isOpened]);

  useEffect(() => {
    return () => {
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isOpened) {
      sendOpenNotification('envelope');
    }
  }, [isOpened]);



  return (
    <div
      ref={wrapperRef}
      className={`envelope-wrapper ${isExpanded ? 'expanded' : ''} ${isOpened ? 'flap' : ''}`}
      onClick={handleClick}
    >
      <div className="envelope">
        <div className="envelope-back" /> 
        <div className="letter">
          <div className="text">
            <strong>Ms. Threxy,</strong>

            <p>
            Happy Birthday, Masungit!! <br />
            Thank you for everything, <br />
            for being exactly who you are, <br />
            and for crossing paths with me. <br />
            You may not know it, <br />
            but you made a positive difference in my life. <br />
            I hope you always remember <br />
            that you are appreciated, valued, <br />
            and cared for more than you know. <br />
            I can care for you in 4 ways, <br />
            With words, with silence, with presence, with prayer. <br />
            Or maybe just 3, <br />
            With my eyes, my hands, my heart. <br />
            No, 2 might be stronger, <br />
            With gratitude, and with sincerity. <br />
            Or maybe just 1 is all I need, <br />
            To always wish you happiness. <br />
            Happy Birthday, Ms. Threxy. 💛
            </p>
          </div>
        </div>
      </div>
      <div className="heart"></div>
    </div>
  );
};

export default EnvelopeCard;
